import { differenceInMinutes } from 'date-fns/differenceInMinutes';

const DEFAULT_DEFINITIONS_CACHE_MINUTES = 1;
const DEFINITIONS_CACHE_MINUTES =
  import.meta.env.VITE_DEFINITIONS_CACHE_MINUTES !== undefined
    ? Number(import.meta.env.VITE_DEFINITIONS_CACHE_MINUTES)
    : DEFAULT_DEFINITIONS_CACHE_MINUTES;

export const edsCheckStoredEntityExpired = (timeStamp: number | null) => {
  if (!timeStamp) return true;

  const differenceInMinutesResult = differenceInMinutes(new Date(), new Date(timeStamp));
  return differenceInMinutesResult >= DEFINITIONS_CACHE_MINUTES;
};
